export type Article = {
  slug: string
  title: string
  excerpt: string
  category: 'Producten' | 'Huidkennis' | 'Energetisch werk'
  readTime: string
  date: string
  image?: string
}

export type Episode = {
  number: number
  title: string
  guest: string
  duration: string
  summary: string
}

export const founder = {
  name: 'Sarah Piening',
  firstName: 'Sarah',
  role: 'Huidspecialist & oprichter',
  portrait:
    'https://cdn.magicpatterns.com/uploads/8fhxQztuHxKb8PGxm2Fvw9/Sarah-Piening-mobiel.jpg',
  atWork:
    'https://cdn.magicpatterns.com/uploads/azzLeCawxKA2qtysfHbXME/18113845093809152-s-80-400.jpg',
  withProducts:
    'https://cdn.magicpatterns.com/uploads/m4i5JC6c4qT7zLae7QU6Hb/18173167903394575-s-80-400.jpg',
  portraitPalm:
    'https://cdn.magicpatterns.com/uploads/gixDmFYTUQBuLWRvyJprdG/18324627148173462-s-80-400.jpg',
}

export const salon = {
  city: 'Amsterdam-Oost',
  address: 'Beauty Bewust · Amsterdam-Oost',
  email: 'saarvoorbeauty@gmail.com',
  phone: '+31 6 12 34 56 78',
  whatsapp: 'https://wa.me/31612345678',
  responseTime: 'Binnen 24 uur persoonlijk antwoord',
}

const FLOWERSPICE = 'https://cdn.magicpatterns.com/uploads/rWx56TqkqpdAq1p3r54Crp/pasted-image.jpg'

export const articles: Article[] = [
  {
    slug: 'flower-and-spice',
    title: 'Flower & Spice — nieuwe productlijn online',
    excerpt:
      'Bij Beauty Bewust gaat het om bewuste keuzes maken, voor jouw welzijn én voor de planeet. Deze modern apothecary-lijn is met zorg geselecteerd: rijk, botanisch en zonder opvulling.',
    category: 'Producten',
    readTime: '4 min',
    date: '3 juli 2026',
    image: FLOWERSPICE,
  },
  {
    slug: 'emerginc-spf-30-tinted',
    title: 'emerginC SPF 30+ tinted is er weer',
    excerpt:
      'Midden in de winter missen veel van jullie juist dat egale tintje. Heb je last van pigmentvlekken? Dan is deze SPF in combinatie met het vitamine C serum precies wat je nodig hebt.',
    category: 'Producten',
    readTime: '3 min',
    date: '18 juni 2026',
  },
  {
    slug: 'energetische-facelift',
    title: 'Energetische facelift',
    excerpt:
      'Is het mogelijk om er jonger uit te zien en je jonger te voelen zonder injecties, acupunctuur of ander trauma aan het lichaam? Het antwoord is ja — dit doet de access energetische facelift.',
    category: 'Energetisch werk',
    readTime: '6 min',
    date: '29 mei 2026',
  },
  {
    slug: 'droge-huid-in-de-winter',
    title: 'Droge huid in de winter',
    excerpt:
      'Vanaf de herfst kan je huid flink lijden onder de droogte. Wat je van binnenuit kunt doen met voeding, en wat je huid van buitenaf nodig heeft.',
    category: 'Huidkennis',
    readTime: '7 min',
    date: '11 mei 2026',
  },
  {
    slug: 'waarom-emerginc',
    title: 'Waarom emerginC jouw nieuwe skincare routine is',
    excerpt:
      'Duurzaam is een product dat zin heeft en doet waarvoor het gemaakt is. Daarom werk ik met emerginC: cosmeceutical formules, herplant bos en de nieuwste plantbased ingrediënten.',
    category: 'Producten',
    readTime: '5 min',
    date: '22 april 2026',
  },
]

export const episodes: Episode[] = [
  {
    number: 12,
    title: 'Je huid liegt niet',
    guest: 'met orthomoleculair therapeut Ilse de Boer',
    duration: '48 min',
    summary:
      'Over de link tussen darmen, stress en hardnekkige onzuiverheden — en waar je begint als alles tegelijk speelt.',
  },
  {
    number: 11,
    title: 'Anti-ageing zonder angst',
    guest: 'solo-aflevering',
    duration: '34 min',
    summary:
      'Waarom ik niet geloof in het bestrijden van rimpels, maar wel in een huid die stevig en gezond blijft.',
  },
  {
    number: 10,
    title: 'Plantbased dat écht werkt',
    guest: 'over kokosolie, amandelolie en marketing',
    duration: '41 min',
    summary:
      'Populaire ingrediënten die vaak niets doen — of precies het tegenovergestelde. Waar je wél op let in een ingrediëntenlijst.',
  },
]

export const pressLogos = [
  {
    name: "Women's Health",
    image: 'https://cdn.magicpatterns.com/uploads/1vdgdNRTrWZxij2QbhpfZh/Womans-Health.jpg',
    height: 'h-6 sm:h-7',
  },
  {
    name: 'Go With The Glow',
    image: 'https://cdn.magicpatterns.com/uploads/7i7wY9LogHd22uG3So76F2/Go-with-the-flow.jpg',
    height: 'h-10 sm:h-12',
  },
]

export const pressMentions = ['BeautyJournaal', 'LINDA.', 'Marie Claire']

export const testimonials = [
  {
    quote:
      'Na jaren van zuren en antibiotica is mijn huid eindelijk rustig. Niet door één wonderproduct, maar doordat Sarah me leerde wat ik zelf thuis moest doen.',
    name: 'Sanne V.',
    context: 'hormonale huid, 34',
  },
  {
    quote:
      'De bindweefselmassage in kuurvorm heeft mijn doffe teint compleet omgedraaid. Ik ga nu elke drie weken.',
    name: 'Marjolein D.',
    context: 'klant sinds 2019',
  },
  {
    quote:
      'De enige plek in Amsterdam waar ik niet het gevoel krijg dat me iets wordt aangesmeerd.',
    name: 'Fleur K.',
    context: 'redacteur & klant',
  },
]

export type Concern = {
  id: string
  label: string
  description: string
  treatment: string
  productSkinType: string
}

export const concerns: Concern[] = [
  {
    id: 'hormonaal',
    label: 'Hormonen uit balans',
    description:
      'Door zwangerschap of overgang reageert je huid anders: onzuiverheden rond kaaklijn en kin, gevoeligheid, ontstekinkjes die blijven hangen.',
    treatment: 'Get the Red Out',
    productSkinType: 'Hormonale huid',
  },
  {
    id: 'pigmentatie',
    label: 'Pigmentatie',
    description:
      'Vlekken die na de zomer of een zwangerschap zijn blijven zitten en je teint onrustig maken.',
    treatment: 'Vitamine C Behandeling',
    productSkinType: 'Pigmentatie',
  },
  {
    id: 'veroudering',
    label: 'Verslapping & lijntjes',
    description:
      'Verlies van stevigheid rond kaak en ogen, hangende oogleden en fijne lijntjes — zonder dat je wilt prikken of snijden.',
    treatment: 'Cosmic Botox',
    productSkinType: 'Rijpere huid',
  },
  {
    id: 'dof',
    label: 'Doffe, onregelmatige huid',
    description:
      'Weinig glans, ruwe textuur, make-up die blijft liggen. De huid die het meest baat heeft bij een bindweefselkuur.',
    treatment: 'Goddess Lift',
    productSkinType: 'Droge huid',
  },
  {
    id: 'stress',
    label: 'Stress & spanning',
    description:
      'Je huid is niet het probleem — je hoofd staat aan. Tijd voor twee uur volledig offline.',
    treatment: 'Restoration of Juvenation',
    productSkinType: 'Gevoelige huid',
  },
]

export const philosophy = {
  claim: '70% van je resultaat haal je thuis',
  body: 'Je bent niet met één behandeling klaar. Net als bij sporten: één keer naar de gym maakt je geen fitness goddess. In de salon werk ik met cosmeceutical emerginC — ingrediënten die bijna medicinaal zijn — maar het resultaat komt pas als jij thuis ook serieus aan de slag gaat.',
}
